
<!--
  ■■■■■■■プロフィール編集画面■■■■■■■
-->
<!--
  コンポーネント呼び出し
  ＊  profileEdit - ポップアップを出すトリガー
  ＊profuid - プロフィールのuid
  <profile_edit :profileEdit="profileEdit" @closeProedit="closeProedit"></profile_edit>

  追加関数
  closeProedit() {
      this.profileEdit = false;
      this.updateinfo(this.profuid);
    },
-->
<template>
  <v-main class="pa-0">
    <v-dialog
      v-if="device == 'pc'"
      v-model="trig"
      width="800px"
      class="pa-4 ma-2"
    >
      <v-card>
        <v-card-title style="font-size: 30px">
          プロフィールの設定
          <v-spacer></v-spacer>
          <v-btn
            rounded
            elevation="0"
            color="#008CFF"
            class="white--text"
            @click="submitProfiles()"
          >
            設定完了
          </v-btn>
        </v-card-title>
        <v-container fluid>
          <v-row dense>
            <!--左側(画像)-->
            <v-col cols="4">
              <v-card elevation="0">
                <v-avatar v-if="profImageO" size="224">
                  <v-img
                    v-bind:src="profImageO"
                    class="white--text align-end ma-0"
                  >
                  </v-img>
                </v-avatar>
                <v-avatar v-else size="224">
                  <v-img
                    src="../../../assets/png/someone.png"
                    class="white--text align-end ma-0"
                  >
                  </v-img>
                </v-avatar>
              </v-card>
              <profimg_upload @getImageUrl="getImageUrl" />
            </v-col>
            <!--右側(他)-->
            <v-col cols="8">
              <!--名前-->
              <v-card-title class="py-1" style="color: #66baff">
                ハンドルネーム
              </v-card-title>
              <div>
                <v-col class="px-2">
                  <v-card-text class="d-flex" v-if="!nameSettings">
                    <span style="font-size: 20px">{{ currentName }}</span>
                    <v-btn
                      color="#707070" dark
                      data-testid="profile_edit_nameSettings"
                      @click="
                        (nameSettings = true),
                        (emailSettings = false),
                        (passwordSettings = false)
                      "
                      class="ml-auto"
                      rounded
                    >
                      <v-icon color="white">mdi-cog</v-icon>
                      変更
                    </v-btn>
                  </v-card-text>
                  <v-text-field
                    v-else
                    v-model="newName"
                    :counter="handleNameLength"
                  >
                  </v-text-field>
                  <div class="d-flex">
                    <v-btn
                      class="ml-auto mr-2"
                      rounded
                      @click="nameSettings = false"
                      v-if="nameSettings"
                    >
                      キャンセル
                    </v-btn>
                    <v-btn
                      class="deepAqua white--text"
                      rounded
                      @click="(nameSettings = false), submitenewname()"
                      v-if="nameSettings"
                      :disabled="!newName || newName.length > handleNameLength"
                    >
                      決定
                    </v-btn>
                  </div>
                </v-col>
              </div>
              <!-- メール・パスワード・LINEなど設定画面 -->
              <div>
                <!--メアド-->
                <div v-if="!email || !email.endsWith('.liqlid.local')">
                  <v-card-title class="pb-0" style="color: #66baff">
                    メールアドレス
                  </v-card-title>
                  <v-col class="px-2">
                    <v-card-text v-if="!emailSettings" class="d-flex">
                      {{ email || '未設定' }}
                      <v-btn
                        color="#707070" dark
                        data-testid="profile_edit_emailSettings"
                        @click="
                          (emailSettings = true),
                            (nameSettings = false),
                            (passwordSettings = false)
                        "
                        class="ml-auto"
                        rounded
                      >
                        <v-icon color="white">mdi-cog</v-icon>
                        {{  email ? '変更' : '設定' }}
                      </v-btn>
                    </v-card-text>
                    <div v-else>
                      <p v-if="authFeedbackMessage.length">
                        {{ authFeedbackMessage }}
                      </p>
                      <!-- 今までのメールアドレス -->
                      今までのアドレス：{{ email || '未設定' }}
                      <v-text-field
                        v-model="newEmail"
                        label="新しいメールアドレス"
                      ></v-text-field>
                      <!-- パスワード -->
                      <v-text-field
                        v-model="currentPassword"
                        :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                        :type="show ? 'text' : 'password'"
                        @click:append="show = !show"
                        :placeholder="`${email ? '安全のため、現在使用中の' : '新しい'}パスワードを入力してください`"
                        :label="`${email ? '使用中の' : '新しい'}パスワード`"
                      ></v-text-field>
                      <!-- TODO! ここも直す(SLP追加？) -->
                      <div class="d-flex" v-if="authFeedbackMessage!=='LINEでの再認証が必要です。'">
                        <v-btn
                          class="ml-auto mr-2"
                          rounded
                          @click="
                            (emailSettings = false), (authFeedbackMessage = '')
                          "
                        >
                          キャンセル
                        </v-btn>
                        <v-btn
                          class="deepAqua white--text"
                          rounded
                          :disabled="!newEmail || !currentPassword"
                          @click="submitemailpass(), (authFeedbackMessage = '')"
                        >
                          決定
                        </v-btn>
                      </div>
                      <div v-else>
                        <p>
                          セキュリティのため、一度LINEでログインし直す必要があります。<br/>お手数ですが、再認証後に改めてメールアドレスの設定をお願いします。
                        </p>
                        <line-button>LINEで再度ログイン</line-button>
                      </div>
                    </div>
                  </v-col>
                </div>
                <!--パスワード-->
                <div v-if="email && !email.endsWith('.liqlid.local')">
                  <v-card-title class="pb-0" style="color: #66baff">
                    パスワード
                  </v-card-title>
                  <v-col class="px-2">
                    <v-card-text class="d-flex" v-if="!passwordSettings">
                      ・・・・・・・・・
                      <v-btn
                        color="#707070" dark
                        @click="
                          (passwordSettings = true),
                          (nameSettings = false),
                          (emailSettings = false)
                        "
                        class="ml-auto"
                        rounded
                      >
                        <v-icon color="white">mdi-cog</v-icon>
                        変更
                      </v-btn>
                    </v-card-text>
                    <div v-else>
                      <p v-if="authFeedbackMessage.length">
                        {{ authFeedbackMessage }}
                      </p>
                      <v-text-field
                        v-model="newPass"
                        :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                        :type="show1 ? 'text' : 'password'"
                        @click:append="show1 = !show1"
                        name="input-10-1"
                        placeholder="新しく設定するパスワードを入力してください"
                        label="新しいパスワード"
                        hint="英数字8文字以上・大文字、小文字、数字必須"
                        counter
                      ></v-text-field>
                      <!-- パスワード -->
                      <v-text-field
                        v-model="currentPassword"
                        :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                        :type="show ? 'text' : 'password'"
                        @click:append="show = !show"
                        placeholder="安全のため、現在使用中のパスワードを入力してください"
                        label="使用中のパスワード"
                      ></v-text-field>
                      <div class="d-flex">
                        <v-btn
                          class="ml-auto mr-2"
                          rounded
                          @click="
                            (passwordSettings = false), (authFeedbackMessage = '')
                          "
                        >
                          キャンセル
                        </v-btn>
                        <v-btn
                          class="deepAqua white--text"
                          rounded
                          :disabled="!newPass || !currentPassword"
                          @click="submitemailpass(), (authFeedbackMessage = '')"
                        >
                          決定
                        </v-btn>                        
                      </div>
                    </div>
                  </v-col>
                </div>
                <!--LINE-->
                <div v-if="authConfig.line">
                  <v-card-title class="pb-0" style="color: #66baff">
                    LINEアカウント
                  </v-card-title>
                  <v-col class="px-2" v-if="line">
                    LINEアカウントは連携済みです。
                    <!-- 友だち登録をしていなければ案内出して良さそう -->
                  </v-col>
                  <v-col class="px-2" v-else>
                    <line-button mode="merge">LINEを連携する</line-button>
                  </v-col>
                </div>
                <!--SLP-->
                <!-- <div v-if="authConfig.slp">
                  <v-card-title class="pb-0" style="color: #66baff">
                    SLPアカウント
                  </v-card-title>
                  <v-col class="px-2" v-if="slp">
                    SLPアカウントは連携済みです。
                  </v-col>
                  <v-col class="px-2" v-else>
                    <slp-button mode="merge">SLPを連携する</slp-button>
                  </v-col>
                </div> -->
              </div>
              <!--ひとこと自己紹介-->
              <v-card-title class="py-0 pt-4" style="color: #66baff">
                ひとこと自己紹介
              </v-card-title>
              <v-text-field class="px-5 py-0" v-model="hitokoto" hide-details>
              </v-text-field>

              <!--メッセージ-->
              <v-card-title class="pb-0" style="color: #66baff">
                メッセージ
              </v-card-title>
              <v-text-field class="px-5 py-0" v-model="message" hide-details>
              </v-text-field>

              <!--関連リンク-->
              <v-card-title class="py-0 pt-4" style="color: #66baff">
                関連リンク
              </v-card-title>
              <v-text-field class="px-5 py-0" v-model="proLink" hide-details>
              </v-text-field>

              <v-card-title class="mt-4">
                <v-spacer></v-spacer>
                <deleteAccount />
              </v-card-title>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
    <v-dialog v-if="device == 'sp'" v-model="trig" fullscreen class="pa-0 ma-0">
      <v-card class="pa-0">
        <v-card-actions class="align-center">
          <h2>プロフィールの設定</h2>
          <v-spacer></v-spacer>
          <v-icon @click="trig = false" x-large>mdi-close</v-icon>
        </v-card-actions>
        <!--名前-->
        <div>
          <v-card-title class="py-1" style="color: #66baff">
            ハンドルネーム
          </v-card-title>
          <v-col class="px-2">
            <v-card-text class="d-flex" v-if="!nameSettings">
              <span style="font-size: 20px">{{ currentName }}</span>
              <v-btn
                color="#707070" dark
                data-testid="sp_profile_edit_nameSettings"
                @click="
                  (nameSettings = true),
                  (emailSettings = false),
                  (passwordSettings = false)
                "
                class="ml-auto"
                rounded
              >
                <v-icon color="white">mdi-cog</v-icon>
                変更
              </v-btn>
            </v-card-text>
            <v-text-field v-model="newName" v-else> </v-text-field>
            <v-card-actions>
              <v-btn
                class="ml-auto mr-2"
                rounded
                @click="nameSettings = false"
                v-if="nameSettings"
              >
                キャンセル
              </v-btn>
              <v-btn
                class="deepAqua white--text"
                rounded
                @click="(nameSettings = false), submitenewname()"
                v-if="nameSettings"
                :disabled="!newName || newName.length > handleNameLength"
              >
                決定
              </v-btn>              
            </v-card-actions>
          </v-col>
        </div>

        <!--メールアドレス-->
        <div v-if="!email || !email.endsWith('.liqlid.local')">
          <v-card-title class="py-1" style="color: #66baff">
            メールアドレス
          </v-card-title>
          <v-col class="px-2">
            <v-card-text class="d-flex" v-if="!emailSettings">
              <span style="font-size: 20px">{{ email || '未設定' }}</span>
              <v-btn
                color="#707070" dark
                data-testid="sp_profile_edit_emailSettings"
                @click="
                  (emailSettings = true),
                  (nameSettings = false),
                  (passwordSettings = false)
                "
                class="ml-auto"
                rounded
              >
                <v-icon color="white">mdi-cog</v-icon>
                {{  email ? '変更' : '設定' }}
              </v-btn>
            </v-card-text>
            <div v-else>
              <p v-if="authFeedbackMessage.length">
                {{ authFeedbackMessage }}
              </p>
              <!-- 今までのメールアドレス -->
              今までのアドレス：{{ email || '未設定' }}
              <v-text-field
                v-model="newEmail"
                label="新しいメールアドレス"
              ></v-text-field>
              <!-- パスワード -->
              <v-text-field
                v-model="currentPassword"
                :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                :type="show ? 'text' : 'password'"
                @click:append="show = !show"
                :placeholder="`${email ? '安全のため、現在使用中の' : '新しい'}パスワードを入力してください`"
                :label="`${email ? '使用中の' : '新しい'}パスワード`"
              ></v-text-field>
              <!-- TODO! ここも直す(SLP追加？) -->
              <div class="d-flex" v-if="authFeedbackMessage!=='LINEでの再認証が必要です。'">
                <v-btn
                  class="ml-auto mr-2"
                  rounded
                  @click="
                    (emailSettings = false), (authFeedbackMessage = '')
                  "
                >
                  キャンセル
                </v-btn>
                <v-btn
                  class="deepAqua white--text"
                  rounded
                  :disabled="!newEmail || !currentPassword"
                  @click="submitemailpass(), (authFeedbackMessage = '')"
                >
                  決定
                </v-btn>
              </div>
              <div v-else>
                <p>
                  セキュリティのため、一度LINEでログインし直す必要があります。<br/>お手数ですが、再認証後に改めてメールアドレスの設定をお願いします。
                </p>
                <line-button>LINEで再度ログイン</line-button>
              </div>
            </div>
          </v-col>
        </div>

        <!--パスワード-->
        <div v-if="email && !email.endsWith('.liqlid.local')">
          <v-card-title class="py-1" style="color: #66baff">
            パスワード
          </v-card-title>
          <v-col class="px-2">
            <v-card-text class="d-flex" v-if="!passwordSettings">
              <span style="font-size: 20px">・・・・・・・・・</span>
              <v-btn
                color="#707070" dark
                @click="
                  (passwordSettings = true),
                  (nameSettings = false),
                  (emailSettings = false)
                "
                class="ml-auto"
                rounded
              >
                <v-icon color="white">mdi-cog</v-icon>
                変更
              </v-btn>
            </v-card-text>
            <div v-else>
              <p v-if="authFeedbackMessage.length">
                {{ authFeedbackMessage }}
              </p>
              <v-text-field
                v-model="newPass"
                :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                :type="show1 ? 'text' : 'password'"
                @click:append="show1 = !show1"
                name="input-10-1"
                placeholder="新しく設定するパスワードを入力してください"
                label="新しいパスワード"
                hint="英数字8文字以上・大文字、小文字、数字必須"
                counter
              ></v-text-field>
              <!-- パスワード -->
              <v-text-field
                v-model="currentPassword"
                :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                :type="show ? 'text' : 'password'"
                @click:append="show = !show"
                placeholder="安全のため、現在使用中のパスワードを入力してください"
                label="使用中のパスワード"
              ></v-text-field>
              <v-card-actions>
                <v-btn
                  class="ml-auto mr-2"
                  rounded
                  @click="
                    (passwordSettings = false), (authFeedbackMessage = '')
                  "
                >
                  キャンセル
                </v-btn>
                <v-btn
                  class="deepAqua white--text"
                  rounded
                  :disabled="!newPass || !currentPassword"
                  @click="submitemailpass(), (authFeedbackMessage = '')"
                >
                  決定
                </v-btn>                 
              </v-card-actions>
            </div>
          </v-col>
        </div>
        <v-card elevation="0">
          <v-card-title class="py-1" style="color: #66baff">
            プロフィール画像
          </v-card-title>
          <v-card-actions>
            <v-avatar v-if="profImageO" size="100px" class="mx-auto">
              <v-img v-bind:src="profImageO" class="white--text align-end ma-0">
              </v-img>
            </v-avatar>
            <v-avatar v-else size="100px" class="mx-auto">
              <v-img
                src="../../../assets/png/someone.png"
                class="white--text align-end ma-0"
              >
              </v-img>
            </v-avatar>            
          </v-card-actions>
        </v-card>
        <profimg_upload @getImageUrl="getImageUrl" />
        <!--ひとこと自己紹介-->
        <v-card-title class="py-0 pt-4" style="color: #66baff">
          ひとこと自己紹介
        </v-card-title>
        <v-text-field class="px-5 py-0" v-model="hitokoto" hide-details>
        </v-text-field>

        <!--メッセージ-->
        <v-card-title class="pb-0" style="color: #66baff">
          メッセージ
        </v-card-title>
        <v-text-field class="px-5 py-0" v-model="message" hide-details>
        </v-text-field>

        <!--関連リンク-->
        <v-card-title class="py-0 pt-4" style="color: #66baff">
          関連リンク
        </v-card-title>
        <v-text-field class="px-5 py-0" v-model="proLink" hide-details>
        </v-text-field>

        <!--アカウント削除-->
        <v-card-title>
          <v-spacer></v-spacer>
          <deleteAccount />
        </v-card-title>

        <v-card-actions>
          <v-btn
            rounded large
            color="#008CFF"
            class="white--text px-12 mt-6 mx-auto"
            @click="submitProfiles()"
          >
            設定完了
          </v-btn>          
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-main>
</template>
<script>
import firebase from "firebase/app";
import "firebase/database";
import profimg_upload from "./profimg_upload.vue";
import deleteAccount from "../../auth/deleteAccount.vue"
import lineButton from '../../auth/parts/lineButton.vue'
import slpButton from "../../auth/parts/slpButton.vue";
import Toasted from "vue-toasted";
import Vue from "vue";
Vue.use(Toasted,{iconPack : 'material'})
export default {
  name: "profile_edit",
  props: ["profileEdit", "device"],
  components: {
    profimg_upload,
    deleteAccount,
    lineButton,
    // slpButton,
  },
  data() {
    return {
      db: null,
      message: "",
      proLink: "",
      hitokoto: "",
      nameSettings: false,
      passwordSettings: false,
      emailSettings: false,
      uploadedImage: null,
      authFeedbackMessage: "",
      currentPassword: "",
      show: false,
      newEmail: "",
      newPass: "",
      show1: false,
      newName: "",
      handleNameLength: Number(process.env.VUE_APP_VALUE_NAME_LENGTH || "20"),
      profImageS: "",
      profImageO: "",
      authConfig: JSON.parse(process.env.VUE_APP_AUTH || '{}'),  // 例→ {line:1,slp:0,officer:1}
    };
  },
  created() {
    console.log("user", this.$store.state.auth?.user);
    this.db = firebase.firestore();
  },
  mounted() {
    this.updateinfo(this.uid);
  },
  computed: {
    trig: {
      get() {
        return this.profileEdit;
      },
      set() {
        this.$emit("closeProedit");
      },
    },
    uid() {
      return this.$store.state.auth?.user?.uid || "";
    },
    currentName() {
      this.setName();
      return this.$store.state.auth.user.displayName;
    },
    email() {
      return this.$store.state.auth.user.email;
    },
    line() {
      return this.$store.state.auth.user.line;
    },
    slp() {
      return this.$store.state.auth.user.slp;
    },
    isAuthed() {
      return this.$store.state.auth?.isAuthed;
    },
  },
  methods: {
    setName() {
      this.newName = this.$store.state.auth.user.displayName;
    },
    //画像投稿URL取得
    getImageUrl(filename, ideaImage) {
      if (ideaImage != "") {
        //縮小画像
        let filepath1 = "profimages/" + filename + "-sum.jpeg";
        const ref1 = firebase.storage().ref(filepath1);
        ref1.getDownloadURL().then((url) => {
          this.profImageS = url;
          console.log(this.profImageS);
        });
        //圧縮元画像
        let filepath2 = "profimages/" + filename + ".jpeg";
        const ref2 = firebase.storage().ref(filepath2);
        ref2.getDownloadURL().then((url) => {
          this.profImageO = url;
          console.log(this.profImageO);
        });
      } else {
        this.profImageS = "";
        this.profImageO = "";
      }
    },
    today() {
      // 日付をYYYY/MM/DD HH:DD:MI:SS形式で取得
      this.date = new Date();
      this.yyyy = this.date.getFullYear();
      this.mm = this.toDoubleDigits(this.date.getMonth() + 1);
      this.dd = this.toDoubleDigits(this.date.getDate());
      this.hh = this.toDoubleDigits(this.date.getHours());
      this.mi = this.toDoubleDigits(this.date.getMinutes());
      this.se = this.toDoubleDigits(this.date.getSeconds());
      this.ms = this.toDoubleDigits(this.date.getMilliseconds());
      //console.log(this.todayy)
      this.todayy =
        this.yyyy + this.mm + this.dd + this.hh + this.mi + this.se + this.ms;
      this.todayyy = this.yyyy + this.mm + this.dd + this.hh + this.mi;
      this.timeday = this.mm + "/" + this.dd;
      this.timehour = this.hh + ":" + this.mi;
    },
    toDoubleDigits: function (num) {
      num += "";
      if (num.length === 1) {
        num = "0" + num;
      }
      return num;
    },
    updateinfo(uid) {
      this.db
        .collection("0")
        .doc("config")
        .collection("members")
        .doc(uid)
        .get()
        .then((doc) => {
          if (doc.id == uid) {
            if (doc.data().message != undefined) {
              this.message = doc.data().message;
            }
            if (doc.data().hitokoto != undefined) {
              this.hitokoto = doc.data().hitokoto;
            }
            if (doc.data().proLink != undefined) {
              this.proLink = doc.data().relatedLink;
            }
            if (doc.data().profImageO != undefined) {
              this.profImageO = doc.data().profImageO;
            }
            if (doc.data().profImageS != undefined) {
              this.profImageS = doc.data().profImageS;
            }
          }
        }).then(()=>{
          this.$store.dispatch('getMem')
        })
    },
    //プロフィール更新
    submitProfiles() {
      let self = this;
      this.trig = false;
      this.today();
      this.db
        .collection("0")
        .doc("config")
        .collection("members")
        .doc(this.uid)
        .set(
          {
            message: this.message,
            hitokoto: this.hitokoto,
            relatedLink: this.proLink,
            profImageS: this.profImageS,
            profImageO: this.profImageO,
          },
          { merge: true }
        )
        .then(() => {
          self.updateinfo(self.uid);
        })
        .catch((error) => {
          console.error("Error writing document: ", error);
        });
    },
    submitemailpass: async function () {
      let res = null;
      if (!this.email) {
        // LINEにメールを連携する
        res = await this.$store.dispatch('auth/linkEmailAndPassword', {email: this.newEmail, password: this.currentPassword})
      } else if (this.newEmail) {
        res = await this.$store.dispatch("auth/updateEmail", {
          newEmail: this.newEmail,
          currentEmail: this.email,
          currentPassword: this.currentPassword,
        });
      } else if (this.newPass) {
        res = await this.$store.dispatch("auth/updatePassword", {
          newPassword: this.newPass,
          currentEmail: this.email,
          currentPassword: this.currentPassword,
        });
      }
      if (!res.success) {
        if (res?.error?.code == 'auth/requires-recent-login') {
          this.authFeedbackMessage = 'LINEでの再認証が必要です。'
        } else {
          console.log('error:', res)
          this.authFeedbackMessage = res.message;
        }
        console.error(this.authFeedbackMessage)
      } else {
        if (this.newPass) {
          this.showToast();
        } else {
          this.showToast("完了しました。メールアドレス宛に認証メールをお送りしたので、メールをご確認ください。");
        }
        this.emailSettings = false
        this.passwordSettings = false
        window.location.reload();
      }
    },
    showToast(message="完了しました"){
      this.$toasted.success(message, {
        theme: "bubble", 
        position: "top-center", 
        duration : 5000,
      });
    },
    submitenewname: async function () {
      await this.db
        .collection("0")
        .doc("config")
        .collection("members")
        .doc(this.uid)
        .update({
          name: this.newName,
        })
        .then(function (docRef) {
          // 保存に成功した時
        })
        .catch(function (error) {
          // 保存に失敗した時
          console.error("Firebaseユーザ登録失敗: ", error);
        });
      await this.$store.dispatch("auth/updateName", { name: this.newName });
      //再読み込みを行う
      await window.location.reload();
    },
  },
};
</script>
